import { get_cdn_url, use_store } from "../store";

export default function Faces() {
  const { t } = use_store();
  const face_images = [
    "/faces/face1.webp",
    "/faces/face2.webp",
    "/faces/face3.webp",
    "/faces/face4.webp",
  ];

  return (
    <>
      <div className="flex items-center gap-[24px] mb-[4px] mt-[12px] rounded-[4px] border-lines border-[1px] p-[8px]">
        <div className="flex items-center w-full flex flex-row justify-between">
          <div className="eyebrows uppercase">
            {t("Search over a billion accounts")}
          </div>
          <div className="flex flex-row items-center">
            {face_images.map((face, index) => (
              <div
                key={index}
                className="w-[24px] h-[24px] rounded-full overflow-hidden border-[1.5px] border-white"
                style={{
                  marginLeft: index === 0 ? 0 : "-8px",
                  zIndex: face_images.length - index,
                }}
              >
                <img
                  src={get_cdn_url(face)}
                  alt={`Face ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex w-full flex-row flex-1 flex-grow gap-[4px]">
        <div className="flex items-center gap-[0px] rounded-[4px] border-lines border-[1px] p-[8px] eyebrows flex flex-row justify-between items-center flex-1 flex-grow">
          <p>{t("find red flags")}</p>
          <p>🚩</p>
        </div>
        <div className="flex items-center gap-[0px] rounded-[4px] border-lines border-[1px] p-[8px] eyebrows flex flex-row justify-between items-center flex-1 flex-grow">
          <p>{t("See recent follows")}</p>
          <p>👥</p>
        </div>
      </div>
    </>
  );
}


export function FacesLite() {
  const { t } = use_store();
  const face_images = [
    "/faces/face1.webp",
    "/faces/face2.webp",
    "/faces/face3.webp",
    "/faces/face4.webp",
  ];

  return (
    <>
      <div className="flex items-center gap-[24px] mb-[4px] mt-[12px] rounded-[4px] border-lines border-[1px] p-[8px]">
        <div className="flex items-center w-full flex flex-row justify-between">
          <div className="eyebrows uppercase">
            {t("Search over a billion accounts")}
          </div>
          <div className="flex flex-row items-center">
            {face_images.map((face, index) => (
              <div
                key={index}
                className="w-[24px] h-[24px] rounded-full overflow-hidden border-[1.5px] border-white"
                style={{
                  marginLeft: index === 0 ? 0 : "-8px",
                  zIndex: face_images.length - index,
                }}
              >
                <img
                  src={get_cdn_url(face)}
                  alt={`Face ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
